/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Timeframeid2Inputs */

const en__field_timeframeid2 = /** @type {(inputs: _Field_Timeframeid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timeframe`)
};

const de__field_timeframeid2 = /** @type {(inputs: _Field_Timeframeid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeitraum`)
};

/**
* | output |
* | --- |
* | "Timeframe" |
*
* @param {_Field_Timeframeid2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_timeframeid2 = /** @type {((inputs?: _Field_Timeframeid2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Timeframeid2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_timeframeid2(inputs)
	return de__field_timeframeid2(inputs)
});
export { _field_timeframeid2 as "_field_timeframeID" }